/**
 * Editable Bot Version Slice
 *
 * This slice manages the state for editing bot versions in the portal.
 * It includes:
 * - Bot version CRUD operations (fetch, save, validate)
 * - ReactFlow node and edge management
 * - Undo/Redo functionality
 * - Test call operations
 * - Task values management
 */

// Re-export the main slice
export { editableBotVersionSlice } from './slice';

// Re-export types for consumers
export type {
    ImmerStateCreator,
    EditableBotVersionSliceCreator,
    ImmerSet,
    ImmerGet,
} from './types';

// Re-export initial state utilities
export { initialState, createInitialEditingBot } from './initial-state';
